import { render, staticRenderFns } from "./SwitchUser.vue?vue&type=template&id=5fd2ba27&scoped=true&"
import script from "./SwitchUser.vue?vue&type=script&lang=ts&"
export * from "./SwitchUser.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchUser.vue?vue&type=style&index=0&id=5fd2ba27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd2ba27",
  null
  
)

export default component.exports